import { Board, BoardType } from "@sportactics/board-editing";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useSelectBoardType } from "../select-board-type";
import { useBoardLocalPersistence } from "./use-board-local-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBoardLocalSWR() {
  const key = useKey();
  const fetcher = useFetcher();

  return useSWR(key, fetcher, { suspense: true });
}

export function getBoardLocalSWRKey(boardType: BoardType): BoardLocalSWRKey {
  return getSWRKey(SwrStore.LocalBoard, boardType);
}

export type BoardLocalSWRKey = readonly [SwrStore, BoardType];

function useKey(): BoardLocalSWRKey | null {
  const { boardType } = useSelectBoardType();

  if (boardType === undefined) return null;
  return getBoardLocalSWRKey(boardType);
}

function useFetcher(): (key: BoardLocalSWRKey) => Promise<Board | null> {
  const { hasBoard, getBoard } = useBoardLocalPersistence();

  return async ([, boardType]) =>
    (await hasBoard(boardType)) ? getBoard(boardType) : null;
}
